export default "<button class=\"transparent-button\" [disabled]=\"disabled\"><fa-icon [icon]=\"faPlusCircle\"></fa-icon><ng-content></ng-content></button>\n"